/*
Purpose: Add holidays form
Developer: BY R.SD
Date:25/08/2023 
Project: TCMS
*/


import { useNavigate, useLocation, NavLink } from "react-router-dom";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';


import axios from "axios";
import {
    security_key
, BASE_URL} from "../global";


const basicSchema = yup.object().shape({

    hol_title: yup.string().min(2, "Minimum 2 characters required").max(250, "Maximum 250 characters is required.").required("Title is required.").matches(/^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/, "Avoid start & end with a space or comma").matches(/^[^'"\\]*(?:[^'"\\][^'"\\]*)*$/,"Avoid apostrophe & quotes."),
    hol_type: yup.mixed().required("Type is required."),
//     hol_startdate: yup
//     .string()
//     .test('is-valid-date', 'Please provide a valid date.', function (value) {
//       const parsedDate = dayjs(value, 'YYYY-MM-DD');
//       return parsedDate.isValid();
//     }).required("Start date is required."),
//   hol_enddate: yup
//     .string()
//     .test('is-valid-date', 'Please provide a valid date.', function (value) {
//         const parsedDate = dayjs(value, 'YYYY-MM-DD');
//         return parsedDate.isValid();
//     }).required("End date is required."),

hol_startdate: yup
  .string()
  .test('is-valid-date', 'Please provide a valid date.', function (value) {
    const parsedDate = dayjs(value, 'YYYY-MM-DD'); // Update the format here
    return parsedDate.isValid();
  })
  .required("Start date is required."),

hol_enddate: yup
  .string().test('is-valid-date', 'Please provide a valid date.', function (value) {
    const parsedDate = dayjs(value, 'YYYY-MM-DD'); // Update the format here
    return parsedDate.isValid();
  }).test('is-valid-date', 'End date must be greater than start date.', function (value) {
    const startDate = dayjs(this.parent.hol_startdate, 'YYYY-MM-DD');
    const endDate = dayjs(value, 'YYYY-MM-DD');
  
    return endDate.isValid() && (endDate.isSame(startDate, 'day') || endDate.isAfter(startDate, 'day'));
  }).required("End date is required."),

  
});

function AddHolidays() {


    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);

    const navigate = useNavigate();

    const handleCancel = () => {
        navigate("/operating-hoursandholidays");
    };
    const location = useLocation();
    useEffect(() => {
        // Store the previous pathname in sessionStorage
        sessionStorage.setItem('previousPagePathname', location.pathname);
    }, [location.pathname]);

    const currentDate = new Date(); // Get the current date and time
    const formattedDate = currentDate.toISOString().slice(0, 19).replace("T", " "); // Format it as "YYYY-MM-DD HH:mm:ss"
   

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm(); // Reset Formik-controlled fields
        setValues({
            ...initialValues, // Reset select fields
        });
    };

    const initialValues = {
        /*tbl_tutor*/
        hol_title: "",
        hol_type: "",
        hol_startdate: "",
        hol_enddate: "",
        
        /*Common*/
        created_by: "",
        created_on: formattedDate,
        updated_by: "0",
        updated_on: formattedDate,
        visibility: "1",
        fk_cent_key: sessionStorage.getItem('key'),
    };

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingFormValues, setPendingFormValues] = useState(null);
    const handleConfirmedSubmit = async () => {
        setShowConfirmModal(false);  // Close modal
        setIsSubmitting(true);

        try {
            const response = await axios.post(BASE_URL+"API/api_index.php", {
                security_key: security_key,
                mode: "createHoliday",
                ...pendingFormValues,
            });

            if (response.data.success === true && response.data.data === 1) {
                resetFormFields(resetForm, setValues, initialValues);
                toast.success("Success! holiday added", { autoClose: 700 });
                setTimeout(() => navigate("/operating-hoursandholidays"), 3000);
            } else {
                toast.error("Failure! Unable to create holidays. Try again later", { autoClose: 700 });
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Failure! Unable to create holidays. Try again later", { autoClose: 700 });
        } finally {
            setIsSubmitting(false);
        }
    };


    const { values, handleBlur, touched, handleChange, errors, handleSubmit, setTouched, resetForm, setValues } = useFormik({
        // const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        // onSubmit,
        onSubmit: async (formValues) => {
            // Disable the submit button and reset alerts
            setPendingFormValues(formValues);   // Store the form values temporarily
            setShowConfirmModal(true);  
            //set
        },
    });

    
    const options_holidaytype = [
        { value: '', label: '---Select---' },
        { value: 'School Holidays', label: 'School Holidays' },
        { value: 'Public Holidays', label: 'Public Holidays' },
    ];




    return (
        <>
            {/* React alert */}
             <ToastContainer position="top-center" />
             <Modal show={showConfirmModal} variant="danger">
                <Modal.Header>Holiday</Modal.Header>
        
                <Modal.Body>
                <p>Are you sure you want to create a new holiday and apply it to the sessions? </p>
                </Modal.Body>
                <Modal.Footer className="pt-0">
                <div className="mx-auto d-flex gap-2">
                    <Button
                    variant="contained"
                    className="primary-gray"
                    onClick={() => setShowConfirmModal(false)}
                    >
                    Cancel
                    </Button>
                    <Button
                    variant="contained"
                    type="submit"
                    className="primary-filled "
                    disabled={isSubmitting}
                    onClick={() => handleConfirmedSubmit()}
                    >
                    Yes
                    </Button>
                </div>
                </Modal.Footer>
            </Modal>
            
            {/* center form */}
            <Form autoComplete="off" onSubmit={handleSubmit} ref={formRef}>


                <div className="">

                    <div className="mb-3 d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className='page-title'> Add New Holiday </h5>
                            <div role="presentation" >
                                <Breadcrumbs aria-label="breadcrumb" className='my-breadcrumbs'>
                                <NavLink underline="hover" color="inherit" to='/calendar'> Home</NavLink>


                                    <Typography color="text.primary">Holiday</Typography>
                                </Breadcrumbs>
                            </div>
                        </div>
                        {/*<div>
                            <Button className="secondary-filled " variant="contained" onClick={() => navigate(window.history.back())}>
                                Back
                             </Button>
                         </div>*/}
                         
                    </div>

                  

                    {/* --------------Conditions Details--------------- */}
                    <Stack className='mt-4'>
                        <div className="my-card p-4 bg-white">
                            <div className='section-heading border-bottom pb-3 mb-3'>
                                <h6 className='mb-0'>Holidays Details</h6>
                            </div>

                            <Row>
                                {/* --------------Holiday Title--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field">Holiday Title </h6>
                                <Form.Control
                                        type="text"
                                        
                                        id="hol_title"
                                        value={values.hol_title}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={errors.hol_title && touched.hol_title ? "input-error" : ""}
                                    />
                                    {errors.hol_title && touched.hol_title && <p className="error">{errors.hol_title}</p>}
                                </Col>

                                {/* -------------- Holiday Type--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                <h6 className="form-lable required-field"> Holiday Type</h6>
                                
                                       <Select menuPlacement="auto" 
                                        options={options_holidaytype}
                                        
                                        name="hol_type"
                                        id="hol_type"
                                        value={values.hol_type["value"]}
                                        onChange={(selectedOption) => {
                                            const event = {
                                                target: {
                                                    name: "hol_type",
                                                    value: selectedOption["value"],
                                                },
                                            };
                                            handleChange(event);
                                        }}
                                        onBlur={(event) => {
                                            handleBlur(event);
                                            setTouched({ ...touched, hol_type: true });
                                        }}
                                        className={errors.hol_type && touched.hol_type ? "input-error" : ""}
                                    />
                                    {errors.hol_type && touched.hol_type && <p className="error">{errors.hol_type}</p>}
                                </Col>


                                {/* --------------Holiday Start Date--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Holiday Start Date</h6>
                                    {/* <Form.Control
                                        type="date"
                                        id="hol_startdate"
                                        min={new Date().toISOString().split("T")[0]}
                                        value={values.hol_startdate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={errors.hol_startdate && touched.hol_startdate ? "input-error" : ""}
                                    /> */}
                                    <LocalizationProvider className={'form-control'} dateAdapter={AdapterDayjs}>
                                        <DatePicker  views={['year', 'month', 'day']}
                                            value={dayjs(values.hol_startdate, 'YYYY-MM-DD')}
                                            onChange={(date) =>  {
                                                const event = {
                                                target: {
                                                    name: "hol_startdate",
                                                    value: date != null ? dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD') : date,
                                                },
                                                };
                                                handleChange(event);
                                            }}
                                            onBlur={(event) => {
                                                handleBlur(event);
                                                setTouched({ ...touched, hol_startdate: true });
                                            }}
                                            name="hol_startdate"
                                            slotProps={{
                                                textField: { readOnly: true, size: 'small',
                                                    id: 'hol_startdate',
                                                },
                                                }}
                                            className={errors.hol_startdate && touched.hol_startdate ? "input-error w-100" : "w-100"}
                                            minDate={dayjs()}
                                            format="DD-MM-YYYY"
 />
                                    </LocalizationProvider>
                                    {errors.hol_startdate && touched.hol_startdate && <span className="error">{errors.hol_startdate}</span>}
                                </Col>

                                {/* --------------Holiday End Date--------------- */}

                                <Col lg="4" md="6" sm="12" className='position-relative'>
                                    <h6 className="form-lable required-field">Holiday End Date</h6>
                                    {/* <Form.Control
                                        type="date"
                                        id="hol_enddate"
                                        min={values.hol_startdate!=null && values.hol_startdate!=''? values.hol_startdate : new Date().toISOString().split("T")[0]}
                                        value={values.hol_enddate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={errors.hol_enddate && touched.hol_enddate ? "input-error" : ""}
                                    /> */}
                                    <LocalizationProvider className={'form-control'} dateAdapter={AdapterDayjs}>
                                        <DatePicker  views={['year', 'month', 'day']}
                                            value={dayjs(values.hol_enddate, 'YYYY-MM-DD')}
                                            onChange={(date) =>  {
                                                const event = {
                                                target: {
                                                    name: "hol_enddate",
                                                    value: date != null ? dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD') : date,
                                                },
                                                };
                                                handleChange(event);
                                            }}
                                            onBlur={(event) => {
                                                handleBlur(event);
                                                setTouched({ ...touched, hol_enddate: true });
                                            }}
                                            name="hol_enddate"
                                            slotProps={{
                                                textField: { readOnly: true, size: 'small',
                                                    id: 'hol_enddate',
                                                },
                                                }}
                                            className={errors.hol_enddate && touched.hol_enddate ? "input-error w-100" : "w-100"}
                                            minDate={values.hol_startdate!=null && values.hol_startdate!=''? dayjs(values.hol_startdate, 'YYYY-MM-DD') : dayjs()}
                                            format="DD-MM-YYYY"
                                         />
                                    </LocalizationProvider>
                                    {errors.hol_enddate && touched.hol_enddate && <span className="error">{errors.hol_enddate}</span>}
                                </Col>

                               

                            </Row>
                        </div>
                    </Stack>
                    {/* --------------Contact Details End--------------- */}




                    <Stack gap={2} className="mt-4">
                        <div className="text-end">

                            <Button variant="contained" className="primary-gray me-2" onClick={handleCancel}>Cancel</Button>
                            <Button type="submit" variant="contained" className="primary-filled " disabled={showConfirmModal}>Save</Button>
                        </div>
                    </Stack>


                </div>
            </Form>
                    </>  );
}

                export default AddHolidays;